/* assets/fhn-lightbox.js
   Visor de imagen ampliada para móvil en la página de producto.
   - Se abre solo con un toque real (sin movimiento). Si el dedo se desliza, el navegador
     hace scroll o la galería cambia de foto con normalidad: nunca bloqueamos el gesto.
   - Dentro del visor: toca para acercar/alejar, arrastra para recorrer, desliza para cambiar de foto.
   - Se cierra con la X, la tecla Escape o el botón "atrás" del celular.
*/
(function () {
  if (window.__fhnLightbox) return;
  window.__fhnLightbox = true;

  // ===== CONFIGURACIÓN =====
  var CFG = {
    media: '.t4s-product__media-wrapper',          // contenedor de la galería principal
    thumbRatio: 0.4, // una imagen más angosta que el 40% de la galería se trata como miniatura
    mobile: '(max-width: 767px)',
    tapMove: 10,     // px máximos de movimiento para considerar un toque
    tapTime: 350,    // ms máximos de duración de un toque
    zoom: 2.5,       // aumento al tocar dentro del visor
    debug: false     // true = muestra en la consola qué pasa en cada toque
  };

  function log() { if (CFG.debug) console.log.apply(console, ['[fhn-lightbox]'].concat([].slice.call(arguments))); }
  log('cargado');

  var lb, stage, img, count, list = [], index = 0, zoomed = false, open = false;

  function srcOf(el) {
    var s = el.getAttribute('data-master') || el.currentSrc || el.src || '';
    if (!s || s.indexOf('data:') === 0 || /\.svg(\?|$)/.test(s)) s = el.getAttribute('data-src') || s;
    return s.indexOf('//') === 0 ? 'https:' + s : s;
  }

  function galleryImages(root) {
    var seen = {}, out = [];
    root.querySelectorAll('img').forEach(function (el) {
      var s = srcOf(el);
      if (!s || seen[s]) return;
      seen[s] = true;
      out.push(s);
    });
    return out;
  }

  function build() {
    lb = document.createElement('div');
    lb.className = 'fhn-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Imagen ampliada del producto');
    lb.innerHTML =
      '<button type="button" class="fhn-lb__close" aria-label="Cerrar">&times;</button>' +
      '<div class="fhn-lb__stage"><img class="fhn-lb__img" alt=""></div>' +
      '<button type="button" class="fhn-lb__nav fhn-lb__prev" aria-label="Imagen anterior">&#8249;</button>' +
      '<button type="button" class="fhn-lb__nav fhn-lb__next" aria-label="Imagen siguiente">&#8250;</button>' +
      '<p class="fhn-lb__count"></p>';
    document.body.appendChild(lb);
    stage = lb.querySelector('.fhn-lb__stage');
    img = lb.querySelector('.fhn-lb__img');
    count = lb.querySelector('.fhn-lb__count');

    lb.querySelector('.fhn-lb__close').addEventListener('click', function () { history.back(); });
    lb.querySelector('.fhn-lb__prev').addEventListener('click', function () { go(-1); });
    lb.querySelector('.fhn-lb__next').addEventListener('click', function () { go(1); });

    // Tocar la imagen: acercar en el punto tocado / alejar
    img.addEventListener('click', function (e) {
      if (!zoomed) {
        var r = img.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        setZoom(true);
        stage.scrollLeft = px * img.offsetWidth - stage.clientWidth / 2;
        stage.scrollTop = py * img.offsetHeight - stage.clientHeight / 2;
      } else {
        setZoom(false);
      }
    });

    // Deslizar para cambiar de imagen (solo sin zoom; con zoom el arrastre recorre la imagen)
    var sx = 0, sy = 0;
    stage.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (zoomed || e.touches.length) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    }, { passive: true });

    document.addEventListener('keydown', function (e) { if (open && e.key === 'Escape') history.back(); });
    window.addEventListener('popstate', function () { if (open) close(); });
  }

  function setZoom(on) {
    zoomed = on;
    lb.classList.toggle('is-zoomed', on);
    if (!on) { stage.scrollLeft = 0; stage.scrollTop = 0; }
  }

  function show(i) {
    index = (i + list.length) % list.length;
    setZoom(false);
    img.src = list[index];
    count.textContent = list.length > 1 ? (index + 1) + ' / ' + list.length : '';
    lb.classList.toggle('is-single', list.length < 2);
  }

  function go(step) { if (list.length > 1) show(index + step); }

  function openAt(root, el) {
    if (!lb) build();
    list = galleryImages(root);
    var i = list.indexOf(srcOf(el));
    if (i < 0) { list.unshift(srcOf(el)); i = 0; }
    show(i);
    lb.hidden = false;
    open = true;
    document.documentElement.classList.add('fhn-lb-open');
    history.pushState({ fhnLb: true }, '');
    lb.querySelector('.fhn-lb__close').focus({ preventScroll: true });
  }

  function close() {
    open = false;
    lb.hidden = true;
    setZoom(false);
    document.documentElement.classList.remove('fhn-lb-open');
  }

  // ----- Detección del toque en la galería (sin preventDefault: el scroll queda libre) -----
  // Se escucha en window (fase de captura): es lo primero que recibe el toque, antes de que
  // el tema o alguna app puedan detenerlo en el documento.
  // Encuentra la imagen tocada aunque haya una capa encima (enlace, zoom del tema, etc.)
  function findImage(e, root) {
    if (e.target.tagName === 'IMG') return e.target;
    var slide = e.target.closest('.t4s-product__media-item, .t4s-carousel__item, [data-media-id], .is-selected');
    var el = slide && slide.querySelector('img');
    if (el) return el;
    var hits = document.elementsFromPoint ? document.elementsFromPoint(e.clientX, e.clientY) : [];
    for (var i = 0; i < hits.length; i++) {
      if (hits[i].tagName === 'IMG' && root.contains(hits[i])) return hits[i];
    }
    return null;
  }

  var start = null;
  window.addEventListener('pointerdown', function (e) {
    start = null;
    if (open) return;
    if (!window.matchMedia(CFG.mobile).matches) { log('ignorado: pantalla más ancha que', CFG.mobile); return; }
    var root = e.target.closest(CFG.media);
    if (!root) { log('ignorado: el toque no está dentro de', CFG.media, e.target); return; }
    var el = findImage(e, root);
    if (!el) { log('ignorado: no encontré imagen bajo el dedo', e.target); return; }
    // Miniatura = imagen pequeña frente al ancho de la galería (no depende de clases del tema)
    if (el.getBoundingClientRect().width < root.getBoundingClientRect().width * CFG.thumbRatio) {
      log('ignorado: miniatura', el); return;
    }
    start = { x: e.clientX, y: e.clientY, t: Date.now(), el: el, root: root };
    log('toque iniciado', e.pointerType, el);
  }, { passive: true, capture: true });

  // Si el navegador empieza un scroll o la galería un arrastre, cancela el toque
  window.addEventListener('pointercancel', function () {
    if (start) log('cancelado: el navegador tomó el gesto (scroll o deslizamiento)');
    start = null;
  }, { passive: true, capture: true });
  window.addEventListener('pointermove', function (e) {
    if (start && Math.hypot(e.clientX - start.x, e.clientY - start.y) > CFG.tapMove) { log('cancelado: el dedo se movió'); start = null; }
  }, { passive: true, capture: true });

  window.addEventListener('pointerup', function (e) {
    var s = start; start = null;
    if (!s) return;
    if (Date.now() - s.t > CFG.tapTime) { log('cancelado: toque muy largo'); return; }
    if (Math.hypot(e.clientX - s.x, e.clientY - s.y) > CFG.tapMove) { log('cancelado: el dedo se movió'); return; }
    log('abriendo visor con', srcOf(s.el));
    openAt(s.root, s.el);
  }, { passive: true, capture: true });

  // Para probar desde la consola: fhnLightboxDebug(true)
  window.fhnLightboxDebug = function (on) { CFG.debug = on !== false; log('modo debug activo'); };
})();
